import * as Cookies from './cookies';

export type { CookieType } from './types';
export { cookiesAreEnabled } from './cookies';
export default Cookies;
